import React from "react";
import { Redirect } from "react-router-dom";

/** Legacy page — add route is now a dialog on Transport Routes. */
const TransportAddNewRoute = () => (
  <Redirect to="/AdminMain/TransportRoutes" />
);

export default TransportAddNewRoute;
